const { isString } = require("simpul");

const makeTitleLabel = (title) =>
  (isString(title) && title.trim()) || "Untitled";

module.exports = makeTitleLabel;
